/**
 * HTMLCanvasElementからFileオブジェクトを生成する
 * @param canvas 変換対象のHTMLCanvasElement
 * @returns PNG形式のFileオブジェクト
 */
const canvasToFile = async (canvas: HTMLCanvasElement): Promise<File> => {
  return await new Promise<File>((resolve) => {
    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], "map-image.png", { type: "image/png" });
        resolve(file);
      }
    }, "image/png");
  });
};

export { canvasToFile };
